/* Styles for the Edit view that are not in the reference tool. */
.dataNote {
  flex-basis: 100%;
  margin: 0;
  font-size: 12.5px;
  color: var(--muted);
}

/* A long text field someone else is typing in (brief 8.3). */
.locked {
  background: var(--bg) !important;
  border-color: var(--amber-line) !important;
  cursor: not-allowed;
}
.lockNote {
  margin-top: 6px;
  padding: 4px 8px;
  border-left: 3px solid var(--amber-line);
  background: var(--amber-bg);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--ink);
}
